import React from 'react';

const NotFoundPage = () => {
    return (
    <div>
        <h1>404 - Nie odnaleziono strony</h1>
        <p>Strona której szukasz nie została znaleziona!</p>
    </div>
    );
  };

export default NotFoundPage;


// WEBPACK FOOTER //
// ./src/pages/not-found.js